export default "__VITE_ASSET__BhCVdqXc__"